export default {"src":"/_next/static/media/wrong-position-2-sitter.b535a68f.svg","height":61,"width":80,"blurWidth":0,"blurHeight":0};